<template>
  <Dialog
    header="Conta Cancelada"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :style="{ width: '35vw' }"
    :modal="true"
    :closable="false"
  >
    <p style="text-align: justify">
      Sua conta foi cancelada, entre em contato com a administração para a
      readesão ao sistema.
    </p>
    <template #footer>
      <Button
        label="Fechar"
        class="p-button-secondary"
        @click="$emit('update:visible', false)"
      />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'AccountWarningCanceled',
  props: {
    visible: Boolean,
    account: Object,
  },
};
</script>

<style scoped>
</style>